export type DealReference = {
    name: string;
    value: string;
};

export type EcommerceOrderReferences = {
    orderNumber: string;
    tenantId: string;
    orderLink: string;
};

export type DealWithEcommerceReferences = {
    coxAutoReferences?: {
        omsOrderNumber?: string;
        dealRefId?: string;
    };
    references?: DealReference[];
};

export const getDealReferenceValue = (references: DealReference[] | undefined, name: string): string | undefined =>
    Array.isArray(references) ? references.find((reference) => reference?.name === name)?.value : undefined;

export const getEcommerceOrderReferences = (deal?: DealWithEcommerceReferences): Partial<EcommerceOrderReferences> => ({
    orderNumber: deal?.coxAutoReferences?.omsOrderNumber,
    tenantId: getDealReferenceValue(deal?.references, 'tenantId'),
    orderLink: getDealReferenceValue(deal?.references, 'orderDetailsLink')
});
